module.exports = __webpack_public_path__ + "static/media/icons8-delete (1).d9dfe361.svg";